// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-player-container[data-v-27befafa]{padding-bottom:56.25%}.bg-gradient[data-v-27befafa]{background:linear-gradient(180deg,rgba(0,115,122,0) 30%,#00737a)}.play-button[data-v-27befafa]{top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
